import { useMemo } from 'react'

import useUserRights, { UserRole } from 'components/libs/userRights/useUserRights'
import { useIsAccountHelpdeskUser } from 'lib/hooks/useIsAccountHelpdeskUser'
import appConfig from 'config/appConfig'

export interface ValidatedRights {
  canViewPhaseOneFeature: boolean
  canViewPhaseTwoFeature: boolean
}

export type UseUiSwitcherRights = ValidatedRights

export enum UserRights {
  IS_ACCOUNT_ADMIN = UserRole.ACCOUNT_USER
}
export const useUiSwitcherRights = (): UseUiSwitcherRights => {
  const { validatedUserRights, isImpersonatedUser, userFeatures, isPdDomainIdSet } = useUserRights([
    UserRights.IS_ACCOUNT_ADMIN
  ])
  const isAccountHelpdeskUser = useIsAccountHelpdeskUser()

  const [isAccountAdmin] = validatedUserRights

  const canViewPhaseOneFeature = useMemo(
    () =>
      appConfig.APP.IS_ADMIN &&
      (isAccountAdmin || isAccountHelpdeskUser) &&
      !isPdDomainIdSet &&
      !isImpersonatedUser &&
      !!userFeatures?.optInEnabled &&
      !userFeatures.optOutEnabled &&
      !!userFeatures?.isTdfToggleVisible,
    [isAccountAdmin, isImpersonatedUser, userFeatures, isPdDomainIdSet, isAccountHelpdeskUser]
  )

  const canViewPhaseTwoFeature = useMemo(
    () =>
      appConfig.APP.IS_ADMIN &&
      (isAccountAdmin || isAccountHelpdeskUser) &&
      !isPdDomainIdSet &&
      !isImpersonatedUser &&
      !!userFeatures?.optOutEnabled &&
      !!userFeatures?.isTdfToggleVisible,
    [isAccountAdmin, isImpersonatedUser, userFeatures, isPdDomainIdSet, isAccountHelpdeskUser]
  )

  return useMemo(
    () => ({
      canViewPhaseOneFeature,
      canViewPhaseTwoFeature
    }),
    [canViewPhaseOneFeature, canViewPhaseTwoFeature]
  )
}
